import Marionette from "marionette";

import CamPhotoCompositeView from "./CamPhotoCompositeView";
import ControlsView from "./ControlsView";

import UIModal from "../../UIModal";
import langDictionary from "../../../lang/init";
import template from "classes/modals/cam/view/template/MainView.html";
import "css!classes/modals/cam/view/css/MainView";


let MainView = Marionette.LayoutView.extend("MainView", {
    template,

    ui: {
        $cam: ".cam-box",
        $items: ".right-side",
        $controls: ".controls-wrap"
    },

    modelEvents: {
        "change:camRect": "onChangeCamRect"
    },

    initialize(params) {
        this.$el.addClass("Cam no-select");
        this.camPhotoCollection = params.camPhotoCollection;
        this.camPhotosModel = params.camPhotosModel;
        this.controlsModel = params.controlsModel;

        this.settingsModal = null;
    },

    onRender() {
        // плагин камеры, сам по себе не имеет gui
        this.ui.$cam.cam({});
        this.cam = this.ui.$cam.data("cam");
        this.cam.on("error", this.onCamMediaError.bind(this));
        this.cam.on("play", this.onCamPlay.bind(this));
        this.cam.on("capture", this.onCapture.bind(this));

        // рисуем снимки созданные пользователем
        this.camPhotoCompositeView = new CamPhotoCompositeView({
            el: this.ui.$items,
            model: this.camPhotosModel,
            collection: this.camPhotoCollection
        });
        this.camPhotoCompositeView.render();
        this.camPhotoCompositeView.on("showPhoto", this.showPhoto.bind(this));
        this.camPhotoCompositeView.on("select", this.onSelectPhoto.bind(this));

        // кнопки, для управления камерой
        this.controlsView = new ControlsView({
            el: this.ui.$controls,
            model: this.controlsModel
        });
        this.controlsView.render();

        this.controlsView.on("play", function() {
            this.cam.play();
        }.bind(this));

        this.controlsView.on("pause", function() {
            this.cam.pause();
        }.bind(this));

        this.controlsView.on("capture", function() {
            this.controlsView.startCaptureLoading();

            let rect = this.cam.getVideoInnerRect();
            let resolution = this.cam.getResolution();
            let crop = this.controlsModel.getCrop(this.model.attributes, rect, resolution);

            this.cam.capture(crop);
        }.bind(this));

        this.controlsView.on("settings", this.showSettings.bind(this));
    },

    onCamPlay() {
        let rect = this.cam.getVideoInnerRect();
        this.model.set("camRect", rect);
        this.model.set("camResolution", this.cam.getResolution());
        this.controlsView.drawCropRect(rect);
    },

    onCamMediaError(err) {
        console.error(err);
        UIModal.error(langDictionary.getError("cam_media_error"));
    },

    onCapture(capture) {
        this.camPhotoCollection.add(capture);
        this.controlsView.stopCaptureLoading();
    },

    updateSize() {
        if ( !this.cam ) {
            return;
        }

        this.cam.updateSize();
        this.model.set("camRect", this.cam.getVideoInnerRect());
    },

    showPhoto(model) {
        this.cam.showCapture(model.attributes);
        this.controlsView.pause();
    },

    showSettings() {
        // форма одноразовая
        system.apps.run({
            type: "Form2",
            name: "CamSettingsForm",
            onSubmit: function(model) {
                let width = +model.get("WIDTH");
                let height = +model.get("HEIGHT");
                let prop = width / height;

                if ( !prop || !width && !height ) {
                    this.controlsModel.set("ratio", 0);
                } else {
                    this.controlsModel.set("ratio", prop);
                }
            }.bind(this)
        });
    },

    onSelectPhoto(model) {
        let capture = model.toCapture();
        capture.setName(this.model.get("name") + ".png");
        this.trigger("select", capture);
    },

    onChangeCamRect() {
        let rect = this.model.get("camRect");
        this.controlsView.drawCropRect(rect);
    }
});

export default MainView;
